import { OtpInput } from './components/Input';
import { Resend } from './components/Resend';

const Otp = {
	Input: OtpInput,
	Resend,
};

export default Otp;
